import { createAction } from 'redux-actions'

export const muteRemoteVideo = createAction('MUTE_REMOTE_VIDEO')
export const onVideoMuted = createAction('ON_VIDEO_MUTED')
export const muteVideo = createAction('MUTE_VIDEO')
export const onRemoteVideoMuted = createAction('ON_REMOTE_VIDEO_MUTED')
export const onMuteVideoProgressStateUpdate = createAction('ON_MUTE_VIDEO_PROGRESS_STATE_UPDATE')
